module.exports = function() {
  return new Worker(__webpack_public_path__ + "098affb54f705129e72a.worker.js");
};